'use client';
export * from './simple-image';
